<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Alertas de pago</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button @click="consultar" type="button" class="btn-info btn--bigger">
            <i class="fa fa-search"></i>
            <span>Consultar</span>
          </button>
          <button @click="pdf" type="button" class="btn-danger btn--bigger">
            <i class="fa fa-file-pdf"></i><span>PDF</span>
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <div class="card">
          <div class="card__content">
            <div class="row">
              <div class="col-xs-12 col-md-4">
                <div class="form-field select">
                  <div class="select-field">
                    <select
                      @change="changePersonalizada"
                      name="tipo_fecha"
                      id="tipo_fecha"
                      v-model="form.tipo_fecha"
                    >
                      <option value="F">A la fecha</option>
                      <option value="H">Hoy</option>
                      <option value="A">Ayer</option>
                      <option value="P">Personalizada</option>
                    </select>
                    <label for="tipo_fecha">Tipo de fecha</label>
                  </div>
                </div>
              </div>
              <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-4">
                <div class="form-field">
                  <div class="datepicker-field">
                    <VueCtkDateTimePicker
                      id="desde"
                      v-model="form.desde"
                      locale="es"
                      no-label
                      only-date
                      auto-close
                      button-now-translation="Ahora"
                      format="YYYY-MM-DD"
                      formatted="YYYY-MM-DD"
                      label="Seleccione una fecha..."
                    />
                    <label>Desde</label>
                  </div>
                </div>
              </div>
              <div v-show="form.tipo_fecha === 'P'" class="col-xs-12 col-md-4">
                <div class="form-field">
                  <div class="datepicker-field">
                    <VueCtkDateTimePicker
                      id="desde"
                      v-model="form.hasta"
                      locale="es"
                      no-label
                      only-date
                      auto-close
                      button-now-translation="Ahora"
                      format="YYYY-MM-DD"
                      formatted="YYYY-MM-DD"
                      label="Seleccione una fecha..."
                    />
                    <label>Hasta</label>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <div class="select2-field">
                    <v-select
                      placeholder="Seleccione..."
                      id="cliente"
                      @input="inputCliente"
                      v-model="selectedCliente"
                      :options="clientes"
                      label="descripcion"
                    ></v-select>
                    <label for="cliente">Cliente</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12">
            <div class="table-responsive">
              <table>
                <thead>
                  <tr>
                    <th></th>
                    <th>Número de comprobante</th>
                    <th>Vendedor</th>
                    <th>Cliente</th>
                    <th>Fecha de emisión</th>
                    <th>Pagos</th>
                    <th>Subtotal</th>
                    <th>Iva</th>
                    <th>Valor total</th>
                    <th>Total pagado</th>
                    <th>Saldo</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(comprobante, index) in comprobantes" :key="index">
                    <td>
                      <button
                        type="button"
                        @click="verComprobante(comprobante.id_comprobante)"
                        class="btn-info btn--text"
                      >
                        <i class="fa fa-eye"></i>
                      </button>
                    </td>

                    <td>{{ comprobante.numero_documento }}</td>
                    <td>{{ comprobante.vendedor !== null?comprobante.vendedor.nombre:'' }}</td>
                    <td>{{ comprobante.nombre_cliente }}</td>
                    <td>{{ moment(new Date(comprobante.fecha_emision)).format('YYYY-MM-DD') }}</td>
                    <td>
                      <div class="table-responsive">
                        <table>
                          <thead>
                            <tr>
                              <th>Forma de pago</th>
                              <th>Plazo</th>
                              <th>Fecha máxima de pago</th>
                              <th>Diferencia de días</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              :class="{
                                'tr--canceled' : pagoExpirado(formaPago),
                                'tr--pending' : pagoExpectante(formaPago)
                              }"
                              v-for="(formaPago, index2) in comprobante.formas_pago"
                              :key="index2"
                            >
                              <td>{{ formaPago.forma_pago.descripcion }}</td>
                              <td>{{ formaPago.plazo }} {{ formaPago.unidad_tiempo }}</td>
                              <td>{{ formaPago.fecha_maxima_pago }}</td>
                              <td>{{ diasRestantes(formaPago) }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                    <td>
                      <input-field
                        vMoney
                        :format="money"
                        :id="'subtotal' + index"
                        v-model="comprobante.subtotal"
                        readonly
                      ></input-field>
                    </td>
                    <td>
                      <input-field
                        vMoney
                        :format="money"
                        :id="'valor_iva' + index"
                        v-model="comprobante.valor_iva"
                        readonly
                      ></input-field>
                    </td>
                    <td>
                      <input-field
                        vMoney
                        :format="money"
                        :id="'valorTotal' + index"
                        v-model="comprobante.valor_total"
                        readonly
                      ></input-field>
                    </td>
                    <td>
                      <input-field
                        vMoney
                        :format="money"
                        :id="'totalPagado' + index"
                        v-model="comprobante.total_pagado"
                        readonly
                      ></input-field>
                    </td>
                    <td>
                      <input-field
                        vMoney
                        :format="money"
                        :id="'saldo' + index"
                        v-model="comprobante.saldo"
                        readonly
                      ></input-field>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <div class="table-responsive">
              <table>
                <thead>
                  <tr>
                    <th>Total de comprobantes</th>
                    <th>Subtotal</th>
                    <th>Valor IVA</th>
                    <th>Valor total</th>
                    <th>Total pagado</th>
                    <th>Saldo</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {{ totalComprobantes }}
                    </td>
                    <td>
                      {{ moneyFormat(subtotal) }}
                    </td>
                    <td>
                      {{ moneyFormat(valorIva) }}
                    </td>
                    <td>
                      {{ moneyFormat(valorTotal) }}
                    </td>
                    <td>
                      {{ moneyFormat(totalPagado) }}
                    </td>
                    <td>
                      {{ moneyFormat(saldo) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="row center-xs">
          <div class="col-xs-12">
            <button v-show="!hiddenShowMore" type="button" @click="consultarPagos" class="btn-info">
              <i class="fa fa-eye"></i>
              <span>Ver más</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed : {
    totalComprobantes : function () {
      return this.comprobantes.length;
    },
    subtotal : function () {
      let subtotal = 0;
      for (let i = 0; i < this.comprobantes.length; i++) {
        let subt = parseFloat(this.comprobantes[i].subtotal);
        if (isNaN(subt))
          subt = 0;
        subtotal += subt;
      }
      return subtotal;
    },
    valorIva : function () {
      let valorIva = 0;
      for (let i = 0; i < this.comprobantes.length; i++) {
        let valIva = parseFloat(this.comprobantes[i].valor_iva);
        if (isNaN(valIva))
          valIva = 0;
        valorIva += valIva;
      }
      return valorIva;
    },
    valorTotal : function () {
      let valorTotal = 0;
      for (let i = 0; i < this.comprobantes.length; i++) {
        let total = parseFloat(this.comprobantes[i].valor_total);
        if (isNaN(total))
          total = 0;
        valorTotal += total;
      }
      return valorTotal;
    },
    totalPagado : function () {
      let totalPagado = 0;
      for (let i = 0; i < this.comprobantes.length; i++) {
        let total = parseFloat(this.comprobantes[i].total_pagado);
        if (isNaN(total))
          total = 0;
        totalPagado += total;
      }
      return totalPagado;
    },
    saldo : function () {
      let saldo = 0;
      for (let i = 0; i < this.comprobantes.length; i++) {
        let total = parseFloat(this.comprobantes[i].saldo);
        if (isNaN(total))
          total = 0;
        saldo += total;
      }
      return saldo;
    }
  },
  methods: {
    serialize: function(obj) {
        return (
          "?" +
          Object.keys(obj)
          .reduce(function(a, k) {
              let val = obj[k];
              let esArray = false;
              if (val instanceof Date) {
              val = val.toLocaleDateString("en");
              } else if (val instanceof Array) {
              esArray = true;
              let acumulador = "";
              for (let i = 0; i < val.length; i++) {
                  acumulador += k + "%5B%5D=" + val[i];
                  if (i != val.length - 1) {
                  acumulador += "&";
                  }
              }
              val = acumulador;
              a.push(val);
              }
              if (!esArray) a.push(k + "=" + encodeURIComponent(val));
              return a;
          }, [])
          .join("&")
      );
  },
    pdf : function () {
      this.form.imprimir = "S";
      let urlApi = url + "/alertas" + this.serialize(this.form);
      window.open(urlApi, "_blank");
    },
    changePersonalizada: function () {
      if (this.form.tipo_fecha === "P") {
        let desde = new Date();
        desde = desde.setDate(desde.getDate() - 30);
        this.form.desde = moment(desde).format("YYYY-MM-DD");
        this.form.hasta = moment(new Date()).format("YYYY-MM-DD");
      }
    },
    consultar: function () {
      this.form.imprimir = '';
      this.form.itemsPerPage = 15;
      this.form.items = 0;
      this.comprobantes.splice(0, this.comprobantes.length);
      this.consultarPagos();
    },
    inputCliente: function () {
      if (this.selectedCliente !== null)
        this.form.cliente_id = this.selectedCliente.id;
      else this.form.cliente_id = "";
    },
    verComprobante: function (id) {
      window.open(this.url + "/comprobantes/" + id + "/edit", "_blank");
    },
    consultarPagos: function () {
      this.form.imprimir = '';
      let that = this;
      axios
        .get(this.url + "/alertas", {
          params: this.form,
        })
        .then(function (response) {
          that.diasAlerta = response.data.dias_alerta;
          for (let i = 0; i < response.data.comprobantes.length; i++)
            that.comprobantes.push(response.data.comprobantes[i]);
          if (response.data.comprobantes.length !== that.form.itemsPerPage) {
            that.hiddenShowMore = true;
          } else {
            that.form.items += that.form.itemsPerPage;
            that.hiddenShowMore = false;
          }
        });
    },
    pagoExpirado: function (formaPago) {
      let dateInicial = moment(new Date());
      let dateFinal = moment(
        new Date(formaPago.fecha_maxima_pago + " 00:00:00")
      );
      let diferencia = dateFinal.diff(dateInicial, "days") + 1;
      return diferencia < 0;
    },
    pagoExpectante: function (formaPago, fechaEmision) {
      let dateInicial = moment(new Date());
      let dateFinal = moment(
        new Date(formaPago.fecha_maxima_pago + " 00:00:00")
      );
      let diferencia = dateFinal.diff(dateInicial, "days") + 1;
      return diferencia < this.diasAlerta;
    },
    diasRestantes: function (formaPago) {
      let dateInicial = moment(new Date());
      let dateFinal = moment(
        new Date(formaPago.fecha_maxima_pago + " 00:00:00")
      );
      let diferencia = dateFinal.diff(dateInicial, "days") + 1;
      return diferencia;
    },
  },
  mounted: function () {
    this.changePersonalizada();
    this.consultarPagos();
  },
  props: {
    clientes: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
  },
  data: function () {
    return {
      moneyFormat: moneyFormat,
      selectedCliente: null,
      comprobantes: [],
      url: url,
      money: money,
      diasAlerta: 5,
      moment: moment,
      form: {
        itemsPerPage: 15,
        items: 0,
        cliente_id: "",
        desde: "",
        hasta: "",
        tipo_fecha: "F",
      },
      hiddenShowMore: false,
    };
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/comprobantes/Alertas.vue